Ext.define('SA.view.ScatterPlotToolbar', {
    extend: 'SA.view.Toolbar',

    initComponent() {
        this.items = [
            {
                xtype: 'pvt-text',
                text: 'Points represent:'
            }, {
                xtype: 'pvt-auto-refreshing-unit-dropdown',
                projectView: this.model
            }, {
                xtype: 'pvt-text',
                text: 'in'
            }, {
                xtype: 'pvt-auto-refreshing-location-dropdown',
                projectModel: this.model.getProject(),
                projectView: this.model
            }, {
                xtype: 'pvt-fill'
            }, {
                xtype: 'pvt-filtering-button',
                margin: '0 10 0 0'
            }, {
                xtype: 'view-actions-menu-button-2',

                menuItems: [
                    {
                        text: 'Edit View',
                        eventId: 'edit'
                    }, {
                        xtype: 'menuseparator'
                    }, {
                        text: 'Create Data Table',
                        eventId: 'createDataTable'
                    }, {
                        xtype: 'menuseparator'
                    }, {
                        text: 'Delete View',
                        eventId: 'delete'
                    }
                ]
            }, {
                xtype: 'pvt-export-button',
                margin: '0 10 0 0'
            }
        ];

        this.callParent();

        this.filteringButton = this.down('pvt-filtering-button');
        this.viewActionsMenuBtn = this.down('view-actions-menu-button-2');

        this.filteringButton.setMenuCfg({
            xtype: 'filters-window',
            projectView: this.model,
            showVisibilityRadioGroup: false
        });
    },

    initEvents() {
        this.callParent();

        this.viewActionsMenuBtn.on('click:menuItem:edit', () => this.fireEvent('click:viewActions:edit'));
        this.viewActionsMenuBtn.on('click:menuItem:createDataTable', () => this.fireEvent('click:viewActions:createDataTable'));
        this.viewActionsMenuBtn.on('click:menuItem:delete', () => this.fireEvent('click:viewActions:delete'));
    },

    setFilteringButtonIndicatorVisible(visible) {
        this.filteringButton.setIndicatorVisible(visible);
    }
});
